import { type RootState } from '../../stores/redux';

export const getCallDetailsForSurvey = (state: RootState) =>
  state.postCallSurvey.details;
